import { Router } from "@frui.ts/screens/dist";
import BankTransferViewModel from "./bankTransferViewModel";

export const SingleBankTransferNavigationName = "single_bank_transfer";

@Router.registerRoute({ route: `${SingleBankTransferNavigationName}/:orderId`, name: Router.Self })
export default class SingleBankTransferViewModel extends BankTransferViewModel {}
